import store from "@/store"

/**
 * Composable for accessing Vuex store with better type safety and reactivity
 * @returns {object} Store getters and actions
 */
function useStore() {
  // App Config
  const appConfig = computed(() => store.state.appConfig)
  const layoutType = computed(
    () => store.state.appConfig?.layout?.type || "vertical",
  )
  const skin = computed(() => store.state.appConfig?.layout?.skin)
  const contentWidth = computed(
    () => store.state.appConfig?.layout?.contentWidth,
  )
  const isNavMenuHidden = computed(
    () => store.state.appConfig?.layout?.menu?.hidden,
  )

  // Vertical Menu
  const isVerticalMenuCollapsed = computed(
    () => store.state.verticalMenu?.isVerticalMenuCollapsed || false,
  )

  // App State
  const windowWidth = computed(() => store.state.app?.windowWidth)

  // Announcements
  const announcements = computed(() => store.state.announcements || [])

  // Actions
  const updateWindowWidth = (width) => {
    store.commit("app/UPDATE_WINDOW_WIDTH", width)
  }

  const setAnnouncements = (data) => {
    store.commit("SET_ANNOUNCEMENTS", data)
  }

  const updateSkin = (value) => {
    store.commit("appConfig/UPDATE_SKIN", value)
  }

  return {
    // State
    appConfig,
    layoutType,
    skin,
    contentWidth,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    windowWidth,
    announcements,

    // Actions
    updateWindowWidth,
    setAnnouncements,
    updateSkin,

    // Direct store access (for advanced use)
    store,
  }
}

export default useStore
